
import React, { useEffect, useState } from "react";
import { useAuthorization } from "rwo-react";
import { UXPermissions } from "../permissions/UXPermissions";
import { useNavigate } from "react-router-dom";

const Unauthorized: React.FC = () => {
  const [checkingAccess, setCheckingAccess] = useState(true);
  const [, setHasAccess] = useState(false);
  const authorizationService = useAuthorization();
  const navigate = useNavigate();

  useEffect(() => {
    const checkAccess = async () => {
      try {
        await authorizationService.checkAccessForCurrentUser(
          UXPermissions.LMSEventDefinitionToolAccess.resourceId,
          UXPermissions.LMSEventDefinitionToolAccess.action,
        );
        setHasAccess(true);
        navigate("/", { replace: true });
      } catch {
        setHasAccess(false);
      } finally {
        setCheckingAccess(false);
      }
    };
    checkAccess();
  }, [authorizationService, navigate]);

  if (checkingAccess) {
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h1>Checking your access...</h1>
      </div>
    );
  }

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h1>You do not have permission to access this page.</h1>
    </div>
  );
};

export default Unauthorized;
